import "@fontsource/spartan";

const fonts = {
	body: "'Inter', -apple-system, BlinkMacSystemFont, Arial, sans-serif",
	heading: "inherit"
};

export default fonts;